<div *ngIf="aberta" class="fixed inset-0 z-[80] flex items-center justify-center bg-black/40 px-3 backdrop-blur-sm sm:px-4">
  <div class="w-full max-w-[28rem] rounded-md border border-[#d7dde7] bg-white p-5 shadow-[0_16px_36px_rgba(15,23,42,0.2)] dark:border-gray-700 dark:bg-gray-800">
    <h3 class="mb-3 text-[1.50rem] font-semibold leading-[1.08] text-[#1f2937] dark:text-gray-100 sm:text-[1.8rem]">
      Confirmar exclusão do<br>instrumento de avaliação
    </h3>

    <p class="text-base leading-7 text-[#64748b] dark:text-gray-300">
      Esta ação irá <span class="font-semibold text-red-500">excluir</span> o instrumento de avaliação
      <span class="font-semibold text-[#475569] dark:text-gray-100">[{{ instrumento?.sigla }} - {{ instrumento?.descricao }}]</span>
      e todos os dados relacionados (desempenhos dos alunos, pareceres e desempenhos no CHA e/ou objetivos de aprendizagem).
    </p>

    <p class="mt-2 text-base font-semibold leading-7 text-red-500">
      A exclusão é permanente e não poderá ser desfeita.
    </p>

    <p class="mt-1 text-base leading-7 text-[#64748b] dark:text-gray-300">
      Você concorda com a exclusão do instrumento de avaliação?
    </p>

    <label class="mt-3 flex items-center gap-2 text-[0.88rem] font-semibold text-[#1f2937] dark:text-gray-100">
      <input
        type="checkbox"
        [checked]="confirmadoExclusao"
        (change)="onConfirmacaoChange($event)"
        name="instrumentoConfirmadoExclusao"
        class="h-4 w-4 rounded border-gray-300 text-[#f28f8f] focus:ring-[#f28f8f]">
      Concordo e desejo continuar com a exclusão!
    </label>

    <div class="mt-4 flex items-center gap-2">
      <button
        type="button"
        (click)="onConfirmar()"
        [disabled]="!confirmadoExclusao"
        class="h-9 w-1/2 rounded-md border px-4 text-xs font-semibold tracking-[0.01em] text-white transition disabled:cursor-not-allowed disabled:border-[#f5b4b4] disabled:bg-[#f5b4b4] enabled:border-[#ef4444] enabled:bg-[#ef4444]">
        SIM, EXCLUIR
      </button>
      <button
        type="button"
        (click)="onCancelar()"
        class="h-9 w-1/2 rounded-md border border-[#d1d5db] bg-[#f3f4f6] px-4 text-xs font-semibold tracking-[0.01em] text-[#4b5563] dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200">
        CANCELAR
      </button>
    </div>
  </div>
</div>
